import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/authService';
import LoginBackground from './components/LoginBackground';
import CompanyBranding from './components/CompanyBranding';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';

const LoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated using authService
    if (authService.isAuthenticated()) {
      navigate('/hr-dashboard');
    }else {
      navigate('/login');
    }

    // Set page title
    document.title = 'Sign In - c-success recruit Platform';
  }, [navigate]);

  return (
    <LoginBackground>
      <div className="space-y-8 ">
        {/* Company Branding Section */}
        <CompanyBranding />

        {/* Login Form Section */}
        <LoginForm />

        {/* Security Badges Section */}
        <SecurityBadges />
      </div>
    </LoginBackground>
  );
};

export default LoginPage;